import { Typography } from '@mui/material';
import styled, { css } from 'styled-components/macro';

import { Grid } from 'components';
import { HighlightedColor } from 'App/types';

const Ellipsis = css`
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Wrapper = styled.div`
  width: 100%;
  ${(props) => props.theme.breakpoints.up('lg')} {
    box-shadow: 0px 4px 8px ${({ theme }) => theme.palette.custom.boxShadow.color};
  }
`;

const TitleWrapper = styled.div`
  padding: 24px 24px 8px;
  ${(props) => props.theme.breakpoints.up('lg')} {
    padding: 36px 52px 28px;
  }
`;

const Title = styled(Typography)<{ appearance: HighlightedColor }>`
  margin-bottom: 4px;

  ${Ellipsis};
  color: ${({
    theme: {
      palette: {
        common: { black },
      },
    },
  }) => black};
`;

const Subtitle = styled(Typography)`
  color: ${({
    theme: {
      palette: {
        common: { black },
      },
    },
  }) => black};
`;

const ListWrapper = styled.div`
  padding: 0 4px 24px;
  .MuiList-padding {
    padding: 0;
  }
  ${(props) => props.theme.breakpoints.up('lg')} {
    padding: 0 28px 44px 32px;
  }
`;

const Content = styled(Grid)`
  height: 150px;
  margin: 20px 0px;
  color: ${({
    theme: {
      palette: {
        custom: {
          list: { whiteText },
        },
      },
    },
  }) => whiteText};
  white-space: pre-wrap;
`;

export const PaperWithListStyles = {
  Content,
  ListWrapper,
  Subtitle,
  Title,
  Wrapper,
  TitleWrapper,
};
